import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MarketingChrome, MarketingHashLink } from "./MarketingChrome";
import { FLOW_ACCENT, FLOW_IDS, normalizeFlowId } from "./marketingFlows";
import "./MarketingHome.css";

export default function FlowStoryPage() {
  const { flowId } = useParams();
  const { t } = useTranslation();
  const rawId = String(flowId || "").toLowerCase();
  const id = normalizeFlowId(rawId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, rawId]);

  // If user used old bookmark like /flows/pingwe, redirect to /flows/pingwi
  if (rawId !== id && FLOW_IDS.includes(id)) {
    return <Navigate to={`/flows/${id}`} replace />;
  }

  if (!FLOW_IDS.includes(id)) {
    return <Navigate to="/#flows" replace />;
  }

  const others = FLOW_IDS.filter((f) => f !== id);

  return (
    <MarketingChrome>
      <main id="mh-main" className="mh-wrap mh-flow-page" style={{ "--flow-accent": FLOW_ACCENT[id] }}>
        <div className="mh-flow-page__mark" aria-hidden="true" />
        <p className="mh-eyebrow">{t("mhFlowsEyebrow", "The Four Flows")}</p>
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
          <h1 style={{ margin: 0 }}>{t(`mhFlow_${id}_name`)}</h1>
          {t(`mhFlow_${id}_badge`) ? (
            <span className="mh-flow-card__badge" style={{ fontSize: 13, padding: "4px 10px" }}>
              {t(`mhFlow_${id}_badge`)}
            </span>
          ) : null}
        </div>
        <p className="mh-lead">{t(`mhFlow_${id}_mission`)}</p>

        {id === "pingpro" && t("mhFlow_pingpro_commitment") ? (
          <div className="mh-pro-commitment-banner">
            <strong>⚡ {t("mhFlow_pingpro_commitment")}</strong>
          </div>
        ) : null}

        <div className="mh-flow-story-body">
          <p>{t(`mhFlow_${id}_story`)}</p>
        </div>

        <div className="mh-flow-detail-grid">
          <div className="mh-flow-detail-card">
            <h2 style={{ fontSize: 20, marginTop: 0 }}>{t("mhFlowPageWho", "Who it is for")}</h2>
            <p>{t(`mhFlow_${id}_who`)}</p>
          </div>

          <div className="mh-flow-detail-card">
            <h2 style={{ fontSize: 20, marginTop: 0 }}>{t("mhFlowPagePath", "What the SMART path emphasises")}</h2>
            <p>{t(`mhFlow_${id}_path`)}</p>
          </div>

          <div className="mh-flow-detail-card">
            <h2 style={{ fontSize: 20, marginTop: 0 }}>{t("mhFlowPageCoach", "How the coach stays in charge")}</h2>
            <p>{t(`mhFlow_${id}_coach`)}</p>
          </div>
        </div>

        {(id === "pingwi" || id === "pingwe") ? (
          <p className="mh-note" style={{ marginTop: 24 }}>{t("mhTrustPingwe")}</p>
        ) : null}
        {(id === "pingmynd" || id === "pingmind") ? (
          <p className="mh-note" style={{ marginTop: 24 }}>{t("mhFlowPingmindClinical")}</p>
        ) : null}
        {id === "pingpro" ? (
          <p className="mh-note" style={{ marginTop: 24 }}>{t("mhProductMeasureNote")}</p>
        ) : null}

        <div style={{ display: "flex", gap: 12, marginTop: 32, flexWrap: "wrap" }}>
          <MarketingHashLink hashId="pilot" className="mh-btn mh-btn--primary">
            {t("mhRequestPilot", "Request a pilot")}
          </MarketingHashLink>
          <Link to="/login" className="mh-btn mh-btn--ghost">
            {t("mhSignIn", "Sign in")}
          </Link>
        </div>

        <p className="mh-note" style={{ marginTop: 44 }}>
          {t("mhFlowPageOther", "Explore the other Flows")}
        </p>
        <div className="mh-flow-others">
          {others.map((oid) => (
            <Link key={oid} to={`/flows/${oid}`} className="mh-btn mh-btn--ghost">
              {t(`mhFlow_${oid}_name`)}
            </Link>
          ))}
        </div>
      </main>
    </MarketingChrome>
  );
}
